import React from "react";
import "./UserExperienCard.css";
import { FaCheckCircle } from "react-icons/fa";

const Snackbar = ({ message }) => {
  return (
    <div className="snackbar">
      <span className="greenTick">
        <FaCheckCircle />
      </span>
      <span className="message">{message}</span>
    </div>
  );
};

export default Snackbar;